export default "__VITE_ASSET__DhrDuMLK__"